import React from 'react';
import { InfoCircleIcon } from 'icons';

interface IProps {
  description?: string;
  text: string;
}

export const Description = ({ description, text }: IProps) => (
    <div id="info" className="pt-5.5 relative overflow-hidden rounded-2xl bg-white px-5">
      <div className="flex items-center gap-2">
        <InfoCircleIcon />
        <p className="font-semibold">
          {text}
        </p>
      </div>
      <p className="mt-2.5 whitespace-pre-line text-sm">{description}</p>
      <div className="pt-15">
        <div className="trans absolute bottom-0 left-1/2 z-10 -translate-x-1/2 transform">
          <svg width="311" height="34" viewBox="0 0 311 34" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M311 36.0028C172.246 -29.2017 45.8526 8.83424 0 36.0028C17.9423 30.5736 101.673 30.5646 179.423 46.8658C241.623 59.9067 293.058 45.0575 311 36.0028Z"
              fill="#FCD9BD"
            />
          </svg>
        </div>
        <div className="z-9 absolute bottom-0 right-0">
          <svg width="520" height="34" viewBox="0 0 520 34" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M537 36.0028C297.415 -29.2017 79.1731 8.83424 0 36.0028C30.9808 30.5736 175.558 30.5646 309.808 46.8658C417.208 59.9067 506.019 45.0575 537 36.0028Z"
              fill="#FEECDC"
            />
          </svg>
        </div>
        <div className="z-8 absolute -bottom-1 right-0">
          <svg width="119" height="51" viewBox="0 0 119 51" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M135.585 52.5105C97.6146 -31.1956 27.1823 4.72801 0 27.7465C10.6366 23.1466 11.4828 31.6103 57.5745 45.4213C94.4479 56.4702 124.948 60.182 135.585 52.5105Z"
              fill="#D1D5DB"
            />
          </svg>
        </div>
      </div>
    </div>
  );
